export const getAudioProcessingStatus = audioProcessing =>
    String(audioProcessing?.status || '').trim().toLowerCase();

export const isAudioProcessingActive = audioProcessing => {
    const status = getAudioProcessingStatus(audioProcessing);
    return status === 'pending' || status === 'processing';
};

export const getAudioProcessingStatusText = audioProcessing => {
    const status = getAudioProcessingStatus(audioProcessing);
    const outputFormat = String(audioProcessing?.outputFormat || '').trim().toUpperCase();
    const isSummary = outputFormat === 'SUMMARIZED';

    if (status === 'pending') {
        return isSummary ? 'Summarization running in the background.' : 'Transcription running in the background.';
    }

    if (status === 'processing') {
        return isSummary ? 'Summarization running in the background.' : 'Transcription running in the background.';
    }

    if (status === 'failed') {
        return audioProcessing?.error || (isSummary ? 'Summarization failed.' : 'Transcription failed.');
    }

    return null;
};

export const getAudioProcessingStatusTone = audioProcessing =>
    getAudioProcessingStatus(audioProcessing) === 'failed' ? 'error' : 'progress';

export const getApolloErrorMessage = (error, fallbackMessage = 'Request failed. Please try again.') => {
    const graphQLError = error?.graphQLErrors?.find(item => item?.message)?.message;
    if (graphQLError) {
        return graphQLError;
    }

    const networkGraphQLError = error?.networkError?.result?.errors?.find(item => item?.message)?.message;
    if (networkGraphQLError) {
        return networkGraphQLError;
    }

    if (error?.networkError?.message) {
        return error.networkError.message;
    }

    if (error?.message) {
        return error.message;
    }

    return fallbackMessage;
};
